import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { FinancialData } from '@app/shared/interfaces/data/financial-data.interface';
import { NavigationStepComponent } from './navigation-step/navigation-step.component';
import { TopHeaderComponent } from './top-header/top-header.component';
import { Step } from '@app/shared/interfaces/step.interface';
import { ChangeStepService } from '../stepper/service/change-step.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TopHeaderComponent, NavigationStepComponent, CommonModule, SharedModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  @Input() brand = '';
  @Input() model = '';
  @Input() isPortraitDevice = false;

  @Input() financialData!: FinancialData;

  isFinancialCartOpen: boolean = false;

  steps:Step[] = [];

  steps1:Step[] = [
    {
        "stepId": 0,
        "stepNumber": 0,
        "stepName": "features.financingStart.financingTitle",
        "stepUrl": "/main/financing-start",
        "stepUrlBack": ""
    },
    {
        "stepId": 1,
        "stepNumber": 0,
        "stepName": "features.privacySettings.privacySettingsTitle",
        "stepUrl": "/main/privacy-settings",
        "stepUrlBack": "/main/financing-start"
    },
    {
        "stepId": 2,
        "stepNumber": 1,
        "stepName": "core.components.stepper.verticalStep.identification",
        "stepUrl": "/main/step/identification",
        "stepUrlBack": "/main/privacy-settings"
    },
    {
        "stepId": 3,
        "stepNumber": 2,
        "stepName": "core.components.stepper.verticalStep.personalData",
        "stepUrl": "/main/step/personal-data-info",
        "stepUrlBack": "/main/step/identification"
    },
    {
        "stepId": 4,
        "stepNumber": 2,
        "stepName": "core.components.stepper.verticalStep.personalData",
        "stepUrl": "/main/step/personal-data-birth",
        "stepUrlBack": "/main/step/personal-data-info"
    },
    {
        "stepId": 5,
        "stepNumber": 3,
        "stepName": "core.components.stepper.verticalStep.contactDataInfo",
        "stepUrl": "/main/step/contact-data-info",
        "stepUrlBack": "/main/step/personal-data-birth"
    },
    {
        "stepId": 6,
        "stepNumber": 4,
        "stepName": "core.components.stepper.verticalStep.housingData",
        "stepUrl": "/main/step/house-address",
        "stepUrlBack": "/main/step/contact-data-info"
    },
    {
        "stepId": 7,
        "stepNumber": 4,
        "stepName": "core.components.stepper.verticalStep.housingData",
        "stepUrl": "/main/step/house-type",
        "stepUrlBack": "/main/step/house-address"
    },
    {
        "stepId": 8,
        "stepNumber": 5,
        "stepName": "core.components.stepper.verticalStep.workingData",
        "stepUrl": "/main/step/working-situation",
        "stepUrlBack": "/main/step/house-type"
    },
    {
        "stepId": 9,
        "stepNumber": 5,
        "stepName": "core.components.stepper.verticalStep.workingData",
        "stepUrl": "/main/step/contract-type",
        "stepUrlBack": "/main/step/working-situation"
    },
    {
        "stepId": 10,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.additionalData",
        "stepUrl": "/main/step/additional-data-first",
        "stepUrlBack": "/main/step/contract-type"
    },
    {
        "stepId": 11,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.additionalData",
        "stepUrl": "/main/step/additional-data-second",
        "stepUrlBack": "/main/step/additional-data-first"
    },
    {
        "stepId": 12,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.additionalData",
        "stepUrl": "/main/step/additional-data-loan",
        "stepUrlBack": "/main/step/additional-data-second"
    },







    {
        "stepId": 17,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.secureFinancing",
        "stepUrl": "/main/secure-financing",
        "stepUrlBack": "/main/step/additional-data-second"
    },


    {
        "stepId": 18,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.coHolder",
        "stepUrl": "/main/co-holder",
        "stepUrlBack": "/main/secure-financing"
    },


    {
        "stepId": 19,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.preauthorized",
        "stepUrl": "/main/preauthorized",
        "stepUrlBack": "/main/secure-financing"
    }
  ];
/*
  steps2:Step[] = [
    {
        "stepId": 13,
        "stepNumber": 0,
        "stepName": "core.components.stepper.verticalStep.bankDetails",
        "stepUrl": "/main/step/bank-details",
        "stepUrlBack": "/main/preauthorized"
    },
    {
        "stepId": 14,
        "stepNumber": 1,
        "stepName": "core.components.stepper.verticalStep.bankDetails",
        "stepUrl": "/main/step/bank-details",
        "stepUrlBack": "/main/preauthorized"
    },
    {
        "stepId": 15,
        "stepNumber": 2,
        "stepName": "core.components.stepper.verticalStep.recruitment",
        "stepUrl": "/main/step/recruitment",
        "stepUrlBack": "/main/bank-details"
    },
    {
        "stepId": 16,
        "stepNumber": 3,
        "stepName": "core.components.stepper.verticalStep.authentication",
        "stepUrl": "/main/step/authentications/authentication",
        "stepUrlBack": "/main/step/recruitment",
    },
    {
        "stepId": 17,
        "stepNumber": 3,
        "stepName": 'core.components.stepper.verticalStep.authentication',
        "stepUrl": '/main/step/authentications/authentication-data',
        "stepUrlBack": '/main/step/authentications/authentication',
    },
    {
        "stepId": 18,
        "stepNumber": 4,
        "stepName": 'core.components.stepper.verticalStep.documentationData',
        "stepUrl": '/main/step/documentation',
        "stepUrlBack": '/main/step/authentications/authentication-data',
    }
  ];

 */



  steps2:Step[] = [
    {
        "stepId": 20,
        "stepNumber": 0,
        "stepName": "core.components.stepper.verticalStep.bankDetails",
        "stepUrl": "/main/step/bank-details",
        "stepUrlBack": "/main/preauthorized"
    },
    {
        "stepId": 21,
        "stepNumber": 1,
        "stepName": "core.components.stepper.verticalStep.bankDetails",
        "stepUrl": "/main/step/bank-details",
        "stepUrlBack": "/main/preauthorized"
    },
    {
        "stepId": 22,
        "stepNumber": 2,
        "stepName": "core.components.stepper.verticalStep.recruitment",
        "stepUrl": "/main/step/recruitment",
        "stepUrlBack": "/main/bank-details"
    },
    {
        "stepId": 23,
        "stepNumber": 3,
        "stepName": "core.components.stepper.verticalStep.authentication",
        "stepUrl": "/main/step/authentications/authentication",
        "stepUrlBack": "/main/step/recruitment",
    },
    {
        "stepId": 24,
        "stepNumber": 3,
        "stepName": 'core.components.stepper.verticalStep.authentication',
        "stepUrl": '/main/step/authentications/authentication-data',
        "stepUrlBack": '/main/step/authentications/authentication',
    },
    {
        "stepId": 25,
        "stepNumber": 4,
        "stepName": 'core.components.stepper.verticalStep.documentationData',
        "stepUrl": '/main/step/documentation',
        "stepUrlBack": '/main/step/authentications/authentication-data',
    }
  ];



  stepIdSelected = 0;
  stepNumberSelected = 0;

  constructor(
    private changeStepService: ChangeStepService) { }

  ngOnInit(): void {
    //this.isLoading = false;

    this.stepIdSelected = this.changeStepService.currentStepId;

    if(this.stepIdSelected < 20) this.steps = this.steps1;
    else this.steps = this.steps2;

    this.stepNumberSelected = this.steps[this.stepIdSelected].stepNumber;

    this.changeStepService.changedStep.subscribe(stepId => {
      if(stepId < 20) this.steps = this.steps1;
      else this.steps = this.steps2;

      this.stepIdSelected = stepId;

      this.stepNumberSelected = Number (this.steps.find(item => (item.stepId == stepId))?.stepNumber);
    });

  }

  //-------------------------//
  //------EVENT METHODS------//
  //-------------------------//

  isOpenedFinancialCart(evento: boolean) {
    this.isFinancialCartOpen = evento;
  }

}
